import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import SidebarAdmin from "./sidebar_admin";
import "../css/dash_board.css"
import "../css/general_data_style.css"

const ScrollToTop = () => {
    const location = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  };


const DashBoard = ()=>{
    return(
        <>
    <ScrollToTop/>
    <Container fluid className="p-0 w-100 h-100 box_dash_board vh-100">
      <Row className="w-100 m-0 p-0">
      <Col xs={12} lg={2} className="m-0 container-sidebar d-flex align-items-center justify-content-start ">
          <div className="content-side h-100">
            <SidebarAdmin />
          </div>
        </Col>
        <Col xs={12} lg={10}  className="p-0 content-main m-0 d-flex justify-content-center ">
          <div className="w-100 mt-5 h-100 ">
            <Outlet />
          </div>
        </Col>
      </Row>
    </Container>
    </>
    )
}
export default DashBoard;